/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutBottombarCollapse = createReactComponent(
  "layout-bottombar-collapse",
  "IconLayoutBottombarCollapse",
  [
    [
      "path",
      {
        d: "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M20 15h-16", key: "svg-1" }],
    ["path", { d: "M14 8l-2 2l-2 -2", key: "svg-2" }]
  ]
);

export { IconLayoutBottombarCollapse as default };
//# sourceMappingURL=IconLayoutBottombarCollapse.js.map
